import { gql } from '@apollo/client';

export const getComplaintVisitor = gql `
  query GetComplaintVisitor($id: ID!) {
    getComplaintVisitor(id: $id) {
      id
      name
      page
      sitename
      city
      countryName
      countryCode
      postal
      latitude
      longitude
      ip
      stateName
      createdAt
      updatedAt
    }
  }
`;
export const listComplaintVisitors = gql `
  query ListComplaintVisitors(
    $id: ID
    $filter: ModelComplaintVisitorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaintVisitors(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        page
        sitename
        city
        countryName
        countryCode
        postal
        latitude
        longitude
        ip
        stateName
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getComplaintHistoryAction = gql `
  query GetComplaintHistoryAction($id: ID!) {
    getComplaintHistoryAction(id: $id) {
      id
      cognitoId
      name
      email
      page
      actionType
      actionDescription
      actionError
      note
      createdAt
      updatedAt
    }
  }
`;
export const listComplaintHistoryActions = gql `
  query ListComplaintHistoryActions(
    $id: ID
    $filter: ModelComplaintHistoryActionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaintHistoryActions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        cognitoId
        name
        email
        page
        actionType
        actionDescription
        actionError
        note
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getComplaintUser = gql `
  query GetComplaintUser($cognitoId: ID!) {
    getComplaintUser(cognitoId: $cognitoId) {
      cognitoId
      name
      email
      userType
      createdAt
      conformites {
        items {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        nextToken
      }
      complaints {
        items {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const listComplaintUsers = gql `
  query ListComplaintUsers(
    $cognitoId: ID
    $filter: ModelComplaintUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaintUsers(
      cognitoId: $cognitoId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const getComplaint = gql `
  query GetComplaint($confirmation: ID!) {
    getComplaint(confirmation: $confirmation) {
      confirmation
      cognitoId
      statut
      object
      firstname
      lastname
      email
      phone
      company
      complaintType
      description
      createdAt
      modeSoumission
      responsable
      filename
      userComplaint {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      complaintNotes {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintNotesId
        }
        nextToken
      }
      complaintCpgs {
        items {
          id
          complaintId
          cognitoId
          profileName
          content
          createdAt
          updatedAt
          complaintComplaintCpgsId
        }
        nextToken
      }
      updatedAt
      complaintUserComplaintsId
    }
  }
`;
export const listComplaints = gql `
  query ListComplaints(
    $confirmation: ID
    $filter: ModelComplaintFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaints(
      confirmation: $confirmation
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      nextToken
    }
  }
`;
export const getComplaintNote = gql `
  query GetComplaintNote($id: ID!) {
    getComplaintNote(id: $id) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintNotesId
    }
  }
`;
export const listComplaintNotes = gql `
  query ListComplaintNotes(
    $id: ID
    $filter: ModelComplaintNoteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaintNotes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        complaintId
        cognitoId
        profileName
        content
        createdAt
        complaint {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        updatedAt
        complaintComplaintNotesId
      }
      nextToken
    }
  }
`;
export const getComplaintCpg = gql `
  query GetComplaintCpg($id: ID!) {
    getComplaintCpg(id: $id) {
      id
      complaintId
      cognitoId
      profileName
      content
      createdAt
      complaint {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      updatedAt
      complaintComplaintCpgsId
    }
  }
`;
export const listComplaintCpgs = gql `
  query ListComplaintCpgs(
    $id: ID
    $filter: ModelComplaintCpgFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComplaintCpgs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        complaintId
        cognitoId
        profileName
        content
        createdAt
        complaint {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        updatedAt
        complaintComplaintCpgsId
      }
      nextToken
    }
  }
`;
export const getConformite = gql `
  query GetConformite($numeroFiche: ID!) {
    getConformite(numeroFiche: $numeroFiche) {
      numeroFiche
      cognitoId
      emetteur
      dateDetection
      responsableProcessus
      descriptionConstat
      actionImemdiate
      dateAction
      responsableVisa
      responsableRQA
      dateRQA
      constatControle
      dateConstat
      constatEfficacite
      tauxEfficacite
      decisionSuivi
      actionCloture
      visaTraitement
      visaSuivi
      createdAt
      user {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      actions {
        items {
          id
          name
          conformiteId
          description
          createdAt
          updatedAt
          conformiteActionsId
        }
        nextToken
      }
      problems {
        items {
          id
          conformiteId
          name
          description
          createdAt
          updatedAt
          conformiteProblemsId
        }
        nextToken
      }
      correctives {
        items {
          id
          conformiteId
          description
          responsableSuivi
          responsableTraitement
          datePrevue
          createdAt
          updatedAt
          conformiteCorrectivesId
        }
        nextToken
      }
      updatedAt
      complaintUserConformitesId
    }
  }
`;
export const listConformites = gql `
  query ListConformites(
    $numeroFiche: ID
    $filter: ModelConformiteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConformites(
      numeroFiche: $numeroFiche
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      nextToken
    }
  }
`;
export const getConformiteAction = gql `
  query GetConformiteAction($id: ID!) {
    getConformiteAction(id: $id) {
      id
      name
      conformiteId
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteActionsId
    }
  }
`;
export const listConformiteActions = gql `
  query ListConformiteActions(
    $id: ID
    $filter: ModelConformiteActionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConformiteActions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        conformiteId
        description
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteActionsId
      }
      nextToken
    }
  }
`;
export const getConformiteProbleme = gql `
  query GetConformiteProbleme($id: ID!) {
    getConformiteProbleme(id: $id) {
      id
      conformiteId
      name
      description
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteProblemsId
    }
  }
`;
export const listConformiteProblemes = gql `
  query ListConformiteProblemes(
    $id: ID
    $filter: ModelConformiteProblemeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConformiteProblemes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        conformiteId
        name
        description
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteProblemsId
      }
      nextToken
    }
  }
`;
export const getConformiteCorrective = gql `
  query GetConformiteCorrective($id: ID!) {
    getConformiteCorrective(id: $id) {
      id
      conformiteId
      description
      responsableSuivi
      responsableTraitement
      datePrevue
      createdAt
      conformite {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      updatedAt
      conformiteCorrectivesId
    }
  }
`;
export const listConformiteCorrectives = gql `
  query ListConformiteCorrectives(
    $id: ID
    $filter: ModelConformiteCorrectiveFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listConformiteCorrectives(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        conformiteId
        description
        responsableSuivi
        responsableTraitement
        datePrevue
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteCorrectivesId
      }
      nextToken
    }
  }
`;
export const complaintHistoryByCognitoId = gql `
  query ComplaintHistoryByCognitoId(
    $cognitoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintHistoryActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    complaintHistoryByCognitoId(
      cognitoId: $cognitoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        name
        email
        page
        actionType
        actionDescription
        actionError
        note
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const complaintHistoryByEmail = gql `
  query ComplaintHistoryByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintHistoryActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    complaintHistoryByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cognitoId
        name
        email
        page
        actionType
        actionDescription
        actionError
        note
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByEmail = gql `
  query UserByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByUserType = gql `
  query UserByUserType(
    $userType: String!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByUserType(
      userType: $userType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        cognitoId
        name
        email
        userType
        createdAt
        conformites {
          nextToken
        }
        complaints {
          nextToken
        }
        updatedAt
      }
      nextToken
    }
  }
`;
export const complaintByCognitoId = gql `
  query ComplaintByCognitoId(
    $cognitoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintFilterInput
    $limit: Int
    $nextToken: String
  ) {
    complaintByCognitoId(
      cognitoId: $cognitoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      nextToken
    }
  }
`;
export const complaintByStatut = gql `
  query ComplaintByStatut(
    $statut: String!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintFilterInput
    $limit: Int
    $nextToken: String
  ) {
    complaintByStatut(
      statut: $statut
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        confirmation
        cognitoId
        statut
        object
        firstname
        lastname
        email
        phone
        company
        complaintType
        description
        createdAt
        modeSoumission
        responsable
        filename
        userComplaint {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        complaintNotes {
          nextToken
        }
        complaintCpgs {
          nextToken
        }
        updatedAt
        complaintUserComplaintsId
      }
      nextToken
    }
  }
`;
export const noteByComplaintId = gql `
  query NoteByComplaintId(
    $complaintId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    noteByComplaintId(
      complaintId: $complaintId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        complaintId
        cognitoId
        profileName
        content
        createdAt
        complaint {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        updatedAt
        complaintComplaintNotesId
      }
      nextToken
    }
  }
`;
export const cpgByComplaintId = gql `
  query CpgByComplaintId(
    $complaintId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelComplaintCpgFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cpgByComplaintId(
      complaintId: $complaintId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        complaintId
        cognitoId
        profileName
        content
        createdAt
        complaint {
          confirmation
          cognitoId
          statut
          object
          firstname
          lastname
          email
          phone
          company
          complaintType
          description
          createdAt
          modeSoumission
          responsable
          filename
          updatedAt
          complaintUserComplaintsId
        }
        updatedAt
        complaintComplaintCpgsId
      }
      nextToken
    }
  }
`;
export const conformiteByCognitoId = gql `
  query ConformiteByCognitoId(
    $cognitoId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelConformiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conformiteByCognitoId(
      cognitoId: $cognitoId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        numeroFiche
        cognitoId
        emetteur
        dateDetection
        responsableProcessus
        descriptionConstat
        actionImemdiate
        dateAction
        responsableVisa
        responsableRQA
        dateRQA
        constatControle
        dateConstat
        constatEfficacite
        tauxEfficacite
        decisionSuivi
        actionCloture
        visaTraitement
        visaSuivi
        createdAt
        user {
          cognitoId
          name
          email
          userType
          createdAt
          updatedAt
        }
        actions {
          nextToken
        }
        problems {
          nextToken
        }
        correctives {
          nextToken
        }
        updatedAt
        complaintUserConformitesId
      }
      nextToken
    }
  }
`;
export const conformiteActionByConformiteId = gql `
  query ConformiteActionByConformiteId(
    $conformiteId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelConformiteActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conformiteActionByConformiteId(
      conformiteId: $conformiteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        conformiteId
        description
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteActionsId
      }
      nextToken
    }
  }
`;
export const conformiteProblemeByConformiteId = gql `
  query ConformiteProblemeByConformiteId(
    $conformiteId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelConformiteProblemeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conformiteProblemeByConformiteId(
      conformiteId: $conformiteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conformiteId
        name
        description
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteProblemsId
      }
      nextToken
    }
  }
`;
export const conformiteCorrectiveByConformiteId = gql `
  query ConformiteCorrectiveByConformiteId(
    $conformiteId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelConformiteCorrectiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conformiteCorrectiveByConformiteId(
      conformiteId: $conformiteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conformiteId
        description
        responsableSuivi
        responsableTraitement
        datePrevue
        createdAt
        conformite {
          numeroFiche
          cognitoId
          emetteur
          dateDetection
          responsableProcessus
          descriptionConstat
          actionImemdiate
          dateAction
          responsableVisa
          responsableRQA
          dateRQA
          constatControle
          dateConstat
          constatEfficacite
          tauxEfficacite
          decisionSuivi
          actionCloture
          visaTraitement
          visaSuivi
          createdAt
          updatedAt
          complaintUserConformitesId
        }
        updatedAt
        conformiteCorrectivesId
      }
      nextToken
    }
  }
`;
